import jQuery from 'jquery';
import rpBreakpoints, { breakpointCodes } from 'rp-mq-breakpoints';
import { VARIANTS, THEMES } from './mandatoryLogin.constants';

const { WIDE, EXTRA_WIDE } = breakpointCodes;
const {
    VARIANT_1,
    VARIANT_2,
    VARIANT_3,
    VARIANT_4,
    VARIANT_5,
    VARIANT_6,
    VARIANT_7,
    VARIANT_8,
    VARIANT_9,
    VARIANT_10,
    VARIANT_11,
    VARIANT_12,
    VARIANT_13,
    VARIANT_14,
    VARIANT_15,
    VARIANT_16
} = VARIANTS;
const { THEME_SUCCESS } = THEMES;

export default class MandatoryLogin {
    constructor(config) {
        this.config = config;
        global.mandatoryLogin = this;
        document.dispatchEvent(new CustomEvent('rpAuth:MandatoryLoginReady'));
    }

    bindEvents() {
        jQuery(document).on('rpAuth:SignUp', this.onSignUpHandler);
        jQuery(document).on('rpAuth:Close', this.onCloseHandler);
        jQuery(window).on('rpBreakpointsSwitch', this.onSwitchBreakpointsHandler);
        jQuery(this.config.selectors.elementCloseSelector).on('click', this.onCloseHandler);
    }

    unBindEvents() {
        jQuery(document).off('rpAuth:SignUp', this.onSignUpHandler);
        jQuery(document).off('rpAuth:Close', this.onCloseHandler);
        jQuery(window).off('rpBreakpointsSwitch', this.onSwitchBreakpointsHandler);
        jQuery(this.config.selectors.elementCloseSelector).off('click', this.onCloseHandler);
    }

    onSwitchBreakpointsHandler = (event) => {
        const breakpoint = event.originalEvent.detail.breakpoint.code;

        if (this.shouldRender(breakpoint)) {
            this.show();
        } else {
            this.hide();
        }
    };

    onSignUpHandler = (event) => {
        if (event.originalEvent.detail.status === 'success') {
            const activeContainer = jQuery('.RC-cardMandatoryLoginContainer_active');
            this.changeTheme(activeContainer, THEME_SUCCESS);
        }
    };

    onCloseHandler = () => {
        this.destroy();
    };

    getParams = variant => (
        this.config.variants.find(option => option.variant === variant) || null
    );

    show = () => {
        const activeContainer = jQuery('.RC-cardMandatoryLoginContainer_active');
        activeContainer.attr('hidden', false);
    };

    showMandatoryLoginForm = (position) => {
        const showMandatoryLoginEvent = new CustomEvent('rpAuth:ShowMandatoryLogin', {
            detail: {
                step: 'SignUp',
                target: `${position.className} .RC-mandatoryLogIn__form`
            }
        });
        document.dispatchEvent(showMandatoryLoginEvent);
    };

    hide = () => {
        const activeContainer = jQuery('.RC-cardMandatoryLoginContainer_active');
        activeContainer.attr('hidden', true);
    };

    hideMandatoryLoginForm = () => {
        const hideMandatoryLoginEvent = new CustomEvent('rpAuth:HideMandatoryLogin');
        document.dispatchEvent(hideMandatoryLoginEvent);
    };

    changeTheme = (elementContainer, theme) => {
        const { elementSelector } = this.config.selectors;
        const element = jQuery(elementSelector, elementContainer);
        element.attr('class', 'RC-mandatoryLogIn RC-theme');
        element.addClass(`RC-theme_${theme.className}`);
    };

    destroy() {
        this.hide();
        this.unBindEvents();
        this.hideMandatoryLoginForm();
    }

    shouldRender = (breakpoint = rpBreakpoints.current().code) => (
        [WIDE, EXTRA_WIDE].includes(breakpoint)
    );

    init({ position, theme, showName }) {
        const {
            elementSelector,
            elementNameSelector,
        } = this.config.selectors;

        const elementContainer = jQuery(position.className);
        const element = jQuery(elementSelector, elementContainer);
        const elementName = jQuery(elementNameSelector, element);

        if (showName) {
            elementName.text(theme.name);
        } else {
            elementName.text('');
        }

        elementContainer.addClass('RC-cardMandatoryLoginContainer_active');
        this.changeTheme(elementContainer, theme);
        this.showMandatoryLoginForm(position);
    }

    setVariant(variant) {
        const params = this.getParams(variant);

        if (params) {
            this.init(params);
            this.bindEvents();

            if (this.shouldRender()) {
                this.show();
            }
        }
    }

    setVariant1() {
        this.setVariant(VARIANT_1);
    }

    setVariant2() {
        this.setVariant(VARIANT_2);
    }

    setVariant3() {
        this.setVariant(VARIANT_3);
    }

    setVariant4() {
        this.setVariant(VARIANT_4);
    }

    setVariant5() {
        this.setVariant(VARIANT_5);
    }

    setVariant6() {
        this.setVariant(VARIANT_6);
    }

    setVariant7() {
        this.setVariant(VARIANT_7);
    }

    setVariant8() {
        this.setVariant(VARIANT_8);
    }

    setVariant9() {
        this.setVariant(VARIANT_9);
    }

    setVariant10() {
        this.setVariant(VARIANT_10);
    }

    setVariant11() {
        this.setVariant(VARIANT_11);
    }

    setVariant12() {
        this.setVariant(VARIANT_12);
    }

    setVariant13() {
        this.setVariant(VARIANT_13);
    }

    setVariant14() {
        this.setVariant(VARIANT_14);
    }

    setVariant15() {
        this.setVariant(VARIANT_15);
    }

    setVariant16() {
        this.setVariant(VARIANT_16);
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/mandatoryLogin/mandatoryLogin.js